import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './UndoToast.css';

interface UndoToastProps {
  message: string;
  onUndo: () => void;
  onDismiss: () => void;
}

const UndoToast: React.FC<UndoToastProps> = ({ message, onUndo, onDismiss }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(onDismiss, 200);
    }, 5000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  const handleUndo = () => {
    onUndo();
    setIsExiting(true);
    setTimeout(onDismiss, 200);
  };

  return createPortal(
    <div className={`undo-toast ${isExiting ? 'undo-toast--exit' : ''}`} role="alert">
      <span className="undo-toast-message">{message}</span>
      <button className="undo-toast-undo" onClick={handleUndo}>Undo</button>
    </div>,
    document.body
  );
};

export default UndoToast;
